"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FailedProcessing = require("./FailedProcessing");
Object.keys(_FailedProcessing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FailedProcessing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FailedProcessing[key];
    }
  });
});